<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.SELECT_PRODUCTS_TO_ACTIVATE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="previousPageName$ | async"
        [previousPageUrl]="previousPageUrl$ | async"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      />
    </glxy-page-nav>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <div class="row row-gutters page-layout item-selector-table">
      <div class="col col-xs-12 col-sm-8 item-selector-table">
        <ng-container
          *ngIf="{
            config: productSelectorConfig$ | async,
          } as productSelectorData"
        >
          <ng-container
            *ngIf="productSelectorData.config?.itemTypesAvailable?.includes('packages'); else tabbedSelector"
            [ngTemplateOutlet]="itemSelector"
          />

          <ng-template #tabbedSelector>
            <mat-tab-group
              class="item-selector-table"
              mat-stretch-tabs="false"
              mat-align-tabs="start"
              (selectedTabChange)="tabChanged($event)"
            >
              <mat-tab [label]="'COMMON.PRODUCTS' | translate">
                <ng-container [ngTemplateOutlet]="itemSelector" />
              </mat-tab>
              <mat-tab [label]="'COMMON.PACKAGES' | translate">
                <app-paginated-package-activation-table />
              </mat-tab>
            </mat-tab-group>
          </ng-template>

          <ng-template #itemSelector>
            <ng-container *ngIf="productSelectorData.config">
              <inventory-ui-item-selector
                [config]="{
                    partnerId: productSelectorData.config.partnerId,
                    marketId: productSelectorData.config.marketId,
                    businessId: productSelectorData.config.businessId,
                    pageSize: productSelectorData.config.pageSize,
                    country: productSelectorData.config.country,
                    priceType: productSelectorData.config.priceType,
                    itemTypesAvailable: productSelectorData.config.itemTypesAvailable,
                    enforceDependencies: true,
                  }"
                [selectedItems]="selectedItems$ | async"
                [immutableSelectedItems]="immutableSelectedItems$ | async"
                [dependenciesLoading]="productSelectorDependenciesLoading$ | async"
                (selectionChange)="selectedItemsChanged($event)"
              />
            </ng-container>
          </ng-template>
        </ng-container>
      </div>
      <div class="col col-xs-12 col-sm-4 items-list">
        <div *ngIf="this.cartConfig$ | async as config">
          <app-activation-cart
            *ngIf="(pccItemSelectorIncludesPackages$ | async) === false"
            [appCartItems]="selectedAppCartItems$ | async"
            [config]="config"
            (removeApp)="removeSelectedApp($event)"
          />
          <inventory-ui-item-selection-cart
            *ngIf="pccItemSelectorIncludesPackages$ | async"
            [config]="config"
            (removeItem)="removeItem$$.next($event)"
          />
        </div>

        <div class="sticky-button">
          <button
            class="checkout-button"
            [disabled]="disableCheckout$ | async"
            mat-flat-button
            color="primary"
            data-action="proceed-to-next-step"
            (click)="checkoutSelected()"
          >
            {{ 'ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.PROCEED_TO_NEXT_STEP' | translate }}
          </button>
        </div>
        <app-custom-product-recommendations [appCartItems$]="selectedAppCartItems$" />
        <ng-container *ngIf="partnerId$ | async as partnerId">
          <ng-container *ngIf="marketId$ | async as marketId">
            <inventory-ui-active-items [partnerId]="partnerId" [businessId]="accountGroupId" [marketId]="marketId" />
          </ng-container>
        </ng-container>
      </div>
    </div>
  </glxy-page-wrapper>
</glxy-page>
